import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AffiliateLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Please enter email and password'); return; }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API_URL}/api/affiliates/login`, { email, password });
      localStorage.setItem('affiliate_token', res.data.token);
      navigate('/affiliate/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#F9F8F6' }}>
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <p className="text-xs tracking-[0.25em] uppercase mb-2" style={{ color: '#C06C54', fontFamily: "'Manrope', sans-serif" }}>
            Sister Diamonds
          </p>
          <h1 className="text-2xl font-bold" style={{ color: '#1A3C34', fontFamily: "'Playfair Display', serif" }}>
            Affiliate Portal
          </h1>
        </div>

        <form onSubmit={handleLogin} className="space-y-5 p-6 md:p-8 rounded-2xl" style={{ backgroundColor: 'white', boxShadow: '0 4px 24px rgba(26,60,52,0.08)' }}>
          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#1A3C34', fontFamily: "'Manrope', sans-serif" }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border transition-all focus:outline-none focus:ring-2 focus:ring-opacity-40"
              style={{ borderColor: 'rgba(26,60,52,0.15)', fontFamily: "'Manrope', sans-serif" }}
              placeholder="your@email.com"
              data-testid="affiliate-login-email"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#1A3C34', fontFamily: "'Manrope', sans-serif" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border transition-all focus:outline-none focus:ring-2 focus:ring-opacity-40"
              style={{ borderColor: 'rgba(26,60,52,0.15)', fontFamily: "'Manrope', sans-serif" }}
              placeholder="Your password"
              data-testid="affiliate-login-password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3.5 rounded-full text-sm font-semibold transition-all flex items-center justify-center gap-2 disabled:opacity-60"
            style={{ backgroundColor: '#1A3C34', color: '#E8DCCA', fontFamily: "'Manrope', sans-serif" }}
            data-testid="affiliate-login-btn"
          >
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Sign In <ArrowRight className="h-4 w-4" /></>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AffiliateLoginPage;
